
new Vue({
    el:"#connect-app",
    data: {
        allListings: [],
        loaded: false,
        search: "",
        locationDropdown: false,
        areaDropdown: false,
        serviceDropdown: false,
        peopleDropdown: false,
        locations: [],
        categories: [],
        services: [],
        people: [],
        locationFilters: [],
        categoryFilters: [],
        serviceFilters: [],
        peopleFilters: [],
        allLocations: true,
        allCategories: true,
        allServices: true,
        allPeople: true,
        totalFilteredItems: 0,
        Keyword: "",
        countToReturn: 10,
        update: true,
        serviceEnums: {
            1:"Disability / Accessibility / Inclusion",
            2:"Social Services",
            3:"Education / Training / Employment",
            4:"Local Governmnent",
            5:"Health",
            7:"Local Clubs",
            9:"Tourism",
            8:"Business / Commercial",
            11:"Volunteer",
            10:"Community / Residents Association"
        },
        peopleEnums: {
            15:"Parents and caregivers",
            13:"Pets & animals",
            12:"Seniors / older people",
            17:"Whole community",
            7:"Children",
            16:"Families / Whānau",
            8:"Youth",
            9:"Ethnic & migrant communities",
            10:"Māori",
            18:"Disabled people",
            13:"LGBTQI community",
            11:"Pets & animals"
        },
        locationEnums: {
            16:"Whole Wanaka / Upper Clutha area",
            17:"Whole Queenstown / Wakatipu area",
            3:"Wanaka",
            2:"Queenstown",
            26:"Lake Hayes Estate / Shotover Country",
            5:"Kingston",
            24:"Kelvin Heights",
            10:"Hawea / Hawea Flat",
            4:"Glenorchy",
            9:"Frankton",
            7:"District Wide",
            1:"Arrowtown",
        },
        categoryEnums: {
            7:"Arts / Dance / Music / Theatre",
            16:"Childcare / Playgroup / Activities for children",
            15:"Civil Defence and Emergency Management",
            9:"Community Support / Advice / Advocacy",
            6:"Council",
            14:"Culture / Heritage",
            11:"Education / Training",
            13:"Employment & Volunteering",
            12:"Environment / Conservation",
            2:"Health & Wellbeing",
            10:"Hobbies / Crafts",
            8:"Library",
            4:"Religion / Faith / Spiritual",
            5:"Sports / Recreation"
        }
    },
    methods: {
        openListing: function(index, event){
            var self = this;
            var listing = self.allListings[index];
            listing.open = !listing.open;
            self.update = !self.update;

            if (listing.open && listing.longitude != 0 && listing.latitude != 0) {
                var map = self.$refs['listing-map-' + listing.id];
                gmap = new google.maps.Map(map[0], {
                    center: {lat: parseFloat(listing.latitude), lng: parseFloat(listing.longitude) },
                    zoom: parseFloat(listing.zoom)
                })
            }

            self.$nextTick(() => {
                var listingCarousel = self.$refs['listing-carousel-' + index];
                if (listingCarousel[0].classList.contains("js-listing-carousel")){
                    var carousel = new Swiper(listingCarousel[0], {
                        loop:true,
                        navigation: {
                            nextEl: '.c-listing__carousel-btn--next',
                            prevEl: '.c-listing__carousel-btn--prev',
                        },
                    })
                }
            })
        },
        submitRequest: function(){
            var self = this;
            var queryString = "?";
            if (self.Keyword != ""){
                queryString += "&Keyword=" + self.Keyword;
            }
            self.$http.get('/api/Listings/Get' + queryString)
            .then(response => {
                self.allListings = response.data.listings;
                self.allListings.forEach(function(listing, i){

                    if (listing.categories != undefined){
                        listing.categories.forEach(function(category, i){
                            if (self.categories.indexOf(category) == -1){
                                self.categories.push(category);
                            }
                        })
                    }
                    if (listing.services != undefined){
                        listing.services.forEach(function(service, i){
                            if (self.services.indexOf(service) == -1){
                                self.services.push(service);
                            }
                        })
                    }
                    if (listing.peoples != undefined){
                        listing.peoples.forEach(function(people, i){
                            if (self.people.indexOf(people) == -1){
                                self.people.push(people);
                            }
                        })
                    }
                    if (listing.locations != undefined){
                        listing.locations.forEach(function(location, i){
                            if (self.locations.indexOf(location) == -1){
                                self.locations.push(location);
                            }
                        })
                    }

                    listing.shareableUrl = window.location.protocol + '//' + window.location.hostname + '/groups/' + listing.uRLSegment + '/' + listing.id;

                    if (listing.photos != undefined && listing.photos.length > 0){
                        listing.mainPhoto = "https://groups.qldc.govt.nz/" + listing.photos[0].filename;
                    } else {
                        listing.mainPhoto = null;
                    }

                    listing.cleanIntro = (listing.content != undefined) ? listing.content.replace(/<[^>]*>?/gm, '') : "";
                    if (listing.cleanIntro.length > 187){
                        listing.cleanIntro = listing.cleanIntro.slice(0,187) + '...';
                    }
                    listing.index = i;
                    listing.open = false;
                })
            })
        },
        handleClick(e) {
            var self = this;
            if (!e.target.classList.contains("js-dropdown-area")){
                self.locationDropdown = false;
                self.areaDropdown = false;
                self.serviceDropdown = false;
                self.peopleDropdown = false;
            }
        },
        hoverOutTimeout: function() {
            var self = this;

            setTimeout(() => {
                self.locationDropdown = false;
                self.areaDropdown = false;
                self.serviceDropdown = false;
                self.peopleDropdown = false;
            }, 1000);
        },
    },
    computed :{
        filteredListings(){
            var self = this;
            var filteredListings = [];
            self.update;

            if (self.allListings && self.allListings.length > 0) {
                self.allListings.forEach(listing => {

                    // if (self.locationFilters.length && listing.services != undefined && listing.addressTown != null){
                    //     var searchableAddress = listing.addressTown.toLowerCase();
                    //     self.locationFilters.forEach(function(location, i){
                    //         if (searchableAddress.search(location.toLowerCase()) != -1){
                    //             filteredListings.push(listing);
                    //         }
                    //     })
                    // }
                    if (self.Keyword != "") {
                        var re = new RegExp(self.Keyword, "i");
                        if (listing.title.search(re) != -1) {
                            filteredListings.push(listing);
                        }
                    }
                    if (self.categoryFilters.length && listing.categories != undefined) {
                        listing.categories.forEach(function(category, i) {
                            if (self.categoryFilters.indexOf(category) != -1) {
                                filteredListings.push(listing);
                            }
                        })
                    }
                    if (self.locationFilters.length && listing.locations != undefined) {
                        listing.locations.forEach(function(location, i) {
                            if (self.locationFilters.indexOf(location) != -1) {
                                filteredListings.push(listing);
                            }
                        })
                    }
                    if (self.serviceFilters.length && listing.services != undefined) {
                        listing.services.forEach(function(service, i) {
                            if (self.serviceFilters.indexOf(service) != -1) {
                                filteredListings.push(listing);
                            }
                        })
                    }
                    if (self.peopleFilters.length && listing.peoples != undefined) {
                        listing.peoples.forEach(function(people, i) {
                            if (self.peopleFilters.indexOf(people) != -1) {
                                filteredListings.push(listing);
                            }
                        })
                    }
                })
            }


            self.totalFilteredItems = filteredListings.length;
            return filteredListings.slice(0, self.countToReturn);
        }
    },
    watch: {
        allServices(newVal, oldVal){
            if (newVal){
                this.serviceFilters = [];
            }
        },
        allPeople(newVal, oldVal){
            if (newVal){
                this.peopleFilters = [];
            }
        },
        allLocations(newVal, oldVal){
            if (newVal){
                this.locationFilters = [];
            }
        },
        allCategories(newVal, oldVal){
            if (newVal){
                this.categoryFilters = [];
            }
        },
        locationFilters(newVal, oldVal) {
            if (newVal.length > 0){
                this.allLocations = false;
            }
        },
        categoryFilters(newVal, oldVal) {
            if (newVal.length > 0){
                this.allCategories = false;
            }
        },
        serviceFilters(newVal, oldVal) {
            if (newVal.length > 0){
                this.allServices = false;
            }
        },
        peopleFilters(newVal, oldVal) {
            if (newVal.length > 0){
                this.allPeople = false;
            }
        }
    },
    mounted: function()
    {
        var self = this;
        self.$http.get('/api/Listings/Get')
        .then(response => {
            self.allListings = response.data.listings;
            self.allListings.forEach(function(listing, i){

                if (listing.categories != undefined){
                    listing.categories.forEach(function(category, i){
                        if (self.categories.indexOf(category) == -1){
                            self.categories.push(category);
                        }
                    })
                }
                if (listing.services != undefined){
                    listing.services.forEach(function(service, i){
                        if (self.services.indexOf(service) == -1){
                            self.services.push(service);
                        }
                    })
                }
                if (listing.peoples != undefined){
                    listing.peoples.forEach(function(people, i){
                        if (self.people.indexOf(people) == -1){
                            self.people.push(people);
                        }
                    })
                }
                if (listing.locations != undefined){
                    listing.locations.forEach(function(location, i){
                        if (self.locations.indexOf(location) == -1){
                            self.locations.push(location);
                        }
                    })
                }

                listing.shareableUrl = window.location.protocol + '//' + window.location.hostname + '/groups/' + listing.uRLSegment + '/' + listing.id;

                if (listing.photos != undefined && listing.photos.length > 0){
                    listing.mainPhoto = "https://groups.qldc.govt.nz/" + listing.photos[0].filename;
                } else {
                    listing.mainPhoto = null;
                }

                listing.cleanIntro = (listing.content != undefined) ? listing.content.replace(/<[^>]*>?/gm, '') : "";
                if (listing.cleanIntro.length > 187){
                    listing.cleanIntro = listing.cleanIntro.slice(0,187) + '...';
                }
                listing.index = i;
                listing.open = false;
            })
            self.loaded = true;
        })
        window.addEventListener('click', self.handleClick);

        self.$refs.locationDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);
        self.$refs.areaDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);
        self.$refs.serviceDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);
        self.$refs.peopleDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);
    },
    destroyed () {
        window.removeEventListener('click', this.handleClick);
    }
});

























